module.exports = __webpack_public_path__ + "static/technically-awards-winner-badge-2025-product-926dafb01ff43fa8a6551f310052d104.png";